import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
	selector: '[appDecimalOnly]',
})
export class DecimalOnly {
	constructor(private el: ElementRef) {}

	@HostListener('keydown', ['$event'])
	onKeyDown(event: KeyboardEvent) {
		const key = event.key;
		const input = this.el.nativeElement as HTMLInputElement;
		const value = input.value;

		if (
			/[0-9]/.test(key) ||
			['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(
				key
			)
		) {
			return;
		}

		if (key === '-' && value === '' && !input.selectionStart) {
			return;
		}

		if (key === '.' && !value.includes('.')) {
			return;
		}

		event.preventDefault();
	}

	@HostListener('paste', ['$event'])
	onPaste(event: ClipboardEvent) {
		const pasted = (event.clipboardData || (window as any).clipboardData).getData('text');
		if (!/^-?\d*\.?\d*$/.test(pasted)) {
			event.preventDefault();
		}
	}

	@HostListener('input', ['$event'])
	onInput(event: Event) {
		const input = event.target as HTMLInputElement;
		const cleaned = input.value.replace(/[^0-9.-]/g, '');

		const parts = cleaned.split('.');
		if (parts.length > 2) {
			input.value = parts[0] + '.' + parts.slice(1).join('');
		} else {
			input.value = cleaned;
		}

		if (input.value !== cleaned) {
			input.dispatchEvent(new Event('input'));
		}
	}
}
